/*============================================================================
  Shopify's jQuery API
==============================================================================*/
var CartCount = $('span#CartCount.site-header__cart-count');

function floatToString(e, t) {
  var n = e.toFixed(t).toString();
  return n.match(/^\.\d+/) ? "0" + n : n
}

function attributeToString(e) {
  return "string" != typeof e && (e += "", "undefined" === e && (e = "")), jQuery.trim(e)
}

"undefined" == typeof window.Shopify && (window.Shopify = {}), Shopify.money_format = "$", Shopify.onError = function(e, t) {
    var n = eval("(" + e.responseText + ")");
    n.message ? console.log(n.message + "(" + n.status + "): " + n.description) : console.log("Error : " + Shopify.fullMessagesFromErrors(n).join("; ") + ".")
}, Shopify.onCartUpdate = function(e) {
   var itemcount = 0;
   var cartlineitems = [];
   for(var i = 0; i < e.items.length; i++) {
	   if(e.items[i].handle != "2-year-warranty") {
		   itemcount += e.items[i].quantity;

		   cartlineitems.push({
			   'item_id' : e.items[i].product_id,
			   'unit_price' : (e.items[i].price / 100),
			   'quantity' : e.items[i].quantity,
		   });
	   }
   }
   $('span#CartCount.site-header__cart-count').html(itemcount);
   if(e.item_count <= 0) {
	   $('span#CartCount.site-header__cart-count').hide();
   }
   else {
     	$('span#CartCount.site-header__cart-count').show();

   }
}, Shopify.handleize = function (str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
}, jQuery.fn.jquery >= "1.4" ? Shopify.param = jQuery.param : (Shopify.param = function(e) {
    var t = [],
        n = function(e, n) {
            n = jQuery.isFunction(n) ? n() : n, t[t.length] = encodeURIComponent(e) + "=" + encodeURIComponent(n)
        };
    if (jQuery.isArray(e) || e.jquery) jQuery.each(e, function() {
        n(this.name, this.value)
    });
    else
        for (var r in e) Shopify.buildParams(r, e[r], n);
    return t.join("&").replace(/%20/g, "+")
}, Shopify.buildParams = function(e, t, n) {
    jQuery.isArray(t) && t.length ? jQuery.each(t, function(t, r) {
        rbracket.test(e) ? n(e, r) : Shopify.buildParams(e + "[" + ("object" == typeof r || jQuery.isArray(r) ? t : "") + "]", r, n)
    }) : null != t && "object" == typeof t ? Shopify.isEmptyObject(t) ? n(e, "") : jQuery.each(t, function(t, r) {
        Shopify.buildParams(e + "[" + t + "]", r, n)
    }) : n(e, t)
}, Shopify.isEmptyObject = function(e) {
    for (var t in e) return !1;
    return !0
});

